module.exports = __webpack_public_path__ + "static/media/posts-8.a8106804.jpg";